import { useRef } from 'react'
import { addDebuggingData } from 'src/utils/addDebuggingData'

const useHistory = () => {
  const history = useRef<string[]>([])

  function listenForHistory() {
    if (!history.current.length) {
      setInterval(() => {
        const currentUrl = window.location.href
        const lastHistoryUrl = history.current[history.current.length - 1]
        if (currentUrl !== lastHistoryUrl) {
          history.current = [...history.current, currentUrl]
          addDebuggingData('history', history.current)
        }
      }, 200)
    }
  }

  return { listenForHistory, history: history.current }
}

export { useHistory }
